import React, { Component } from 'react';
import OLClusterSource from 'ol/source/cluster';
import OLVectorSource from 'ol/source/vector';

class ClusterSource extends Component {
  constructor(props) {
    super(props);

    this.vectorSource = new OLVectorSource({});
    this.clusterSource = new OLClusterSource({
      source: this.vectorSource,
      style: props.styles
    });

    if(this.props.onReady) {
      this.vectorSource.on('change', (e) => {
        if (this.vectorSource.getState() === 'ready') {
          this.props.onReady(this.vectorSource);
        }
      });
    }

  }

  componentDidMount() {
    const { vectorLayer, features } = this.props;
    this.vectorSource.addFeatures(features);
    vectorLayer.setSource(this.clusterSource);
  }

  componentWillUnmount() {
    const { vectorLayer } = this.props;
    this.vectorSource.clear();

    vectorLayer.setSource(null); // << not sure how to clean this up yet
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.features.length != this.props.features.length) {
      this.vectorSource.clear();
      this.vectorSource.addFeatures(nextProps.features);
    }
  }

  render() {
    return null;
  }
}

ClusterSource.defaultProps = {
  features: []
}

export default ClusterSource;



// WEBPACK FOOTER //
// ./src/components/ol/ClusterSource.js